import React, { useState, useEffect } from "react";
import Theater from "./../../assets/Theater.webp";
import Terax from "./../../assets/slide1.webp";
import Rail from "./../../assets/Industries/terex/tiruttani.jpeg";

const ImageGrid = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const images = [
    {
      id: 1,
      src: Terax,
      text: "Manufacturing Industry",
      subtext: "Design and construction of factories, warehouses, and manufacturing facilities.",
    },
    {
      id: 2,
      src: Theater,
      text: "Entertainment Industry",
      subtext: "Developing spaces such as theaters, auditoriums, and recreational centers.",
    },
    {
      id: 3,
      src: Rail,
      text: "Transportation Sector",
      subtext: "Collaborating on projects like railway station elevations and government contracts.",
    },
  ];

  return (
    <div id="industry" style={{ marginTop: "100px", textAlign: "center" }}>
      {/* Title */}
      <h2 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "10px" }}>
        Our experience in various{" "}
        <span style={{ color: "#5c0e14", fontSize: "50px" }}>Industries</span>
      </h2>
      <p style={{ color: "grey", fontSize: "1rem", marginBottom: "30px" }}>
        We are proud to work with some of the most innovative companies in the industry.
      </p>

      {/* Image Grid */}
      <div
        style={{
          width: "100%",
          display: "grid",
          gap: "10px",
          rowGap: isSmallScreen ? "10px" : "40px",
          overflow: "hidden",

          /* ✅ Large Screens */
          gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr",
          gridTemplateRows: isSmallScreen ? "auto" : "50% 30%",
          gridTemplateAreas: isSmallScreen
            ? `"image1"
               "image2"
               "image3"`
            : `"image1 image1"
               "image2 image3"`,
        }}
      >
        {images.map((image, index) => (
          <div
            key={image.id}
            style={{
              position: "relative",
              overflow: "hidden",
              height: isSmallScreen ? "auto" : index === 0 ? "500px" : "400px", // ✅ Reduced height
              gridArea: index === 0 ? "image1" : index === 1 ? "image2" : "image3",
            }}
          >
            {/* Image */}
            <img
              src={image.src}
              alt={image.text}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                filter: "grayscale(100%)",
                transition: "opacity 0.4s ease",
              }}
            />


            {/* Text Overlay */}
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
                fontWeight: "bold",
                textAlign: "center",
                padding: "10px",
                transition: "background-color 0.4s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#5c0e14"; // 🔥 Only changes background
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
              }}
            >
              {image.text}
              {image.subtext && <p style={{ fontSize: "14px", fontWeight: "normal", padding:"20px" }}>{image.subtext}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGrid;
